import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMedicine } from "../../../Redux/actions/adminActions/medicineActions";

/**
 * show, onHide, medicine
 */
const EditMedicineModal = ({ show, onHide, medicine, refresh }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (medicine) {
      setForm({
        name: medicine.name || "",
        company: medicine.company || "",
        category: medicine.category || "",
        price: medicine.price || 0,
        stock: medicine.stock || 0,
        lowStockLimit: medicine.lowStockLimit || 10,
        description: medicine.description || "",
      });
    }
  }, [medicine]);

  if (!show || !form) return null;

  const submit = (e) => {
    e.preventDefault();
    dispatch(
      updateMedicine(medicine._id, {
        ...form,
        price: Number(form.price),
        stock: Number(form.stock),
        lowStockLimit: Number(form.lowStockLimit),
      })
    );
    refresh();
    onHide();
  };

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content p-3">
          <h5>Edit Medicine</h5>
          <form onSubmit={submit}>
            <div className="row g-2">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  required
                  placeholder="Name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </div>
              <div className="col-sm-6">
                <input
                  className="form-control"
                  placeholder="Company"
                  value={form.company}
                  onChange={(e) =>
                    setForm({ ...form, company: e.target.value })
                  }
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  placeholder="Category"
                  value={form.category}
                  onChange={(e) =>
                    setForm({ ...form, category: e.target.value })
                  }
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  required
                  type="number"
                  placeholder="Price"
                  value={form.price}
                  onChange={(e) => setForm({ ...form, price: e.target.value })}
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  required
                  type="number"
                  placeholder="Stock"
                  value={form.stock}
                  onChange={(e) => setForm({ ...form, stock: e.target.value })}
                />
              </div>
              <div className="col-sm-6 mt-2">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Low stock limit"
                  value={form.lowStockLimit}
                  onChange={(e) =>
                    setForm({ ...form, lowStockLimit: e.target.value })
                  }
                />
              </div>
              <div className="col-12 mt-2">
                <textarea
                  className="form-control"
                  placeholder="Description"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="mt-3 d-flex gap-2">
              <button className="btn btn-primary" type="submit">
                Save
              </button>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={onHide}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditMedicineModal;
